export class CannotRenameFileError extends Error {
  constructor(uuid: string) {
    super(`Error: Unable to rename file ${uuid}. You must be admin to rename files`)
  }
}
